import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import React from 'react';

import type { HandballFixture } from '@swf/generated/graphql/sports/schemas';
import { EventTypeId } from '@swf/sports/types/eventType';
import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

import ScoreboardWrapper from '../ScoreboardWrapper/ScoreboardWrapper';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  eventTime: string;
  handballFixture?: HandballFixture;
  eventId: number;
}

const Handball: React.FC<Props> = ({
  enrichedParticipants,
  handballFixture,
  eventTime,
  eventId
}) => {
  const [participantHome, participantAway] = enrichedParticipants ?? [];
  const currentScore = handballFixture?.score ?? null;

  return (
    <ScoreboardWrapper eventId={eventId} eventTime={eventTime} eventTypeId={EventTypeId.HANDBALL}>
      <Scoreboard>
        <ScoreboardParticipants>
          <ScoreboardParticipant name={participantHome.participant} />
          <ScoreboardParticipant name={participantAway.participant} />
        </ScoreboardParticipants>
        <ScoreboardScores>
          <ScoreboardScore
            score={[currentScore?.home ?? null, currentScore?.away ?? null]}
            scoreCharacterLength={getScoreCharacterLength(EventTypeId.HANDBALL, [
              currentScore?.home ?? 0,
              currentScore?.away ?? 0
            ])}
          />
        </ScoreboardScores>
      </Scoreboard>
    </ScoreboardWrapper>
  );
};

export default Handball;
